export const APP_PATHS = {
  APP_: '/app/',

  ANIMAL_MANAGEMENT: 'animal-management',
  ANIMAL_MANAGEMENT_: 'animal-management/',
  SPECIES_BREED_MANAGEMENT: 'species-management',

  INVENTORY_MANAGEMENT: 'inventory-management',
  INVENTORY_MANAGEMENT_: 'inventory-management/',

  MARKETPLACE_MANAGEMENT: 'admin-marketplace',
  MARKETPLACE_MANAGEMENT_: 'admin-marketplace/',

  TRANSACTION_MANAGEMENT: 'transaction-management',
  TRANSACTION_MANAGEMENT_: 'transaction-management/',
  TRANSACTION_MANAGEMENT_WITHDRAW: 'transaction-management/withdraw/',
  TRANSACTION_MANAGEMENT_ADJUST: 'transaction-management/adjust/',
  TRANSACTION_MANAGEMENT_UPDATE_WITHDRAW_TRANSACTION: 'transaction-management/update-transaction/withdraw/',

  CUSTOMER_INFO: 'customer-info',
  CUSTOMER_INFO_: 'customer-info/',

  LOCATION_MANAGEMENT: 'location-management',
  ADD_ACCOUNT: 'add-account',

  ADMIN_REPORTS: 'admin-reports',
  ADMIN_REPORTS_: 'admin-reports/',

  APPLICATION_TEAM: 'application-team',
  APPLICATION_TEAM_: 'application-team/',

  USER_PROFILE: 'profile',
  USER_PROFILE_: 'profile/',

  ADMIN_SETTINGS: 'admin-settings',
  ON_FARM_BILLING_MANAGEMENT: 'on-farm-billing-management',

  TRANSACTION_CART: 'transaction-cart',
  TRANSACTION_CART_: 'transaction-cart/',
  TRANSACTION_CART_WITHDRAW: 'transaction-cart/withdraw/',
};

export const ACCOUNT_PATHS = {
  DASHBOARD: 'dashboard',

  INVENTORY: 'inventory',
  INVENTORY_: 'inventory/',

  ON_FARM: 'on-farm',
  ON_FARM_: 'on-farm/',

  MARKETPLACE: 'marketplace',
  MARKETPLACE_: 'marketplace/',

  TRANSACTION_HISTORY: 'transaction-history',
  TRANSACTION_HISTORY_: 'transaction-history/',

  REPORTS: 'reports',
  REPORTS_: 'reports/',

  TEAM_MANAGEMENT: 'team-management',
  TEAM_MANAGEMENT_: 'team-management/',

  SETTINGS: 'settings',
  SETTINGS_: 'settings/',
  ACCOUNT_SETTINGS: 'account-settings',

  UPDATE_WITHDRAW_TRANSACTION_: 'update-transaction/withdraw/',
};

export const ON_FARM_PATHS = {
  CANISTER_CONTENTS: 'canister-contents',
  DEPOSIT: 'deposit',
  DISCARD: 'discard',
  EDIT: 'edit',
  FARM_USE: 'farm-use',
  INVENTORY_: 'inventory/',
  INVENTORY: 'inventory',
  ITEM_: ':animalId/',
  ITEM: ':animalId',
  LOCATION_MANAGEMENT: 'location-management',
  MOVE: 'move',
  SELL_TRANSFER: 'sell-transfer',
  SETTINGS: 'settings',
  WITHDRAW: 'withdraw',
};

export const MARKETPLACE_PATHS = {
  MY_LISTING: 'my-listing',
  MY_ORDERS: 'my-orders',
  PROFILE_ACCOUNT: 'profile/:accountId',
  CHECKOUT_: 'checkout/',
  CHECKOUT: 'checkout/:accountId',
  SPECIMEN: ':marketPlaceSpecimenId',
};

export const SETTINGS_PATHS = {
  PASSWORD: 'password',
};

export const INVENTORY_PATHS = {
  ADD_TO_MARKETPLACE: 'add-to-marketplace',
  ITEM: ':animalId',
  ITEM_: ':animalId/',
  SELL: 'sell-transfer',
  WITHDRAW: 'withdraw',
  USE: 'use',
  DISCARD: 'discard',
  UPDATE_TRANSACTION_ITEM: ':transactionId',
};

export const ANIMAL_MANAGEMENT_PATHS = {
  ITEM: ':animalId',
  ITEM_: ':animalId/',
  EDIT: 'edit',
  SPECIMEN: ':specimenId',
};

export const SPECIES_MANAGEMENT_PATHS = {};

export const BREED_MANAGEMENT_PATHS = {};

export const ANIMAL_MANAGEMENT_ANIMAL_PATHS = {
  ANIMAL: ':id',
  ANIMAL_: ':id/',
  EDIT: 'edit',
};

export const INVENTORY_MANAGEMENT_PATHS = {
  COLLECT_DEPOSIT: 'collect-deposit',
  MOVE: 'move',
  CHECK_IN: 'check-in',
  CHECK_OUT: 'check-out',
  DISCARD: 'discard',
  ON_SITE_SELL: 'on-site-sell',
  CUSTOM_DATA_POINTS: 'custom-data-points',
  CANISTER_CONTENTS: 'canister-contents',
  RECONCILE: 'reconcile',
  RECONCILE_: 'reconcile/',
  RECONCILE_ITEM: 'reconcile/:specimenId',
  RSG_CLINIC_USE: 'rsg-clinic-use',
  THRESHOLD: 'threshold',
};

export const MARKETPLACE_MANAGEMENT_PATHS = {
  LISTING: 'listing',
  COMMISSION_REPORT: 'commission-report',
  BREEDER_PAYMENTS: 'breeder-payments',
  SETTINGS: 'settings',
};

export const ADMIN_REPORT_PATHS = {
  INSURED_CUSTOMERS: 'insured-customers',
};

export const REPORT_PATHS = ADMIN_REPORT_PATHS;

export const TEAM_MANAGEMENT_PATHS = {
  EDIT: ':id',
};

export const APPLICATION_TEAM_PATHS = {
  EDIT: ':id',
};

export const CUSTOMER_INFO_PATHS = {
  VIEW: ':accountId',
};

export const TRANSACTION_MANAGEMENT_PATHS = {
  VIEW: ':transactionId',
  CREATE_CLIENT_TRANSACTION: 'create-client-transaction',
  WITHDRAW: 'withdraw/:transactionId',
  ADJUST: 'adjust/:transactionId',
  UPDATE_WITHDRAW_TRANSACTION: 'update-transaction/withdraw/:transactionId',
};

export const USER_PROFILE_PATHS = {
  UPDATE: 'edit-user',
};

export const TRANSACTION_HISTORY_PATHS = {
  VIEW: ':transactionId',
};

export const TRANSACTION_CART_PATHS = {
  WITHDRAW: 'withdraw/:accountId',
};

export const PUBLIC_MARKETPLACE_PATHS = {
  BASE: '/marketplace',
  BASE_: '/marketplace/',
  PROFILE_: '/marketplace/profile/',
  CART: '/marketplace/cart',
  ROUTE_PATTERN: 'marketplace/*',
};

export const ROUTE_PATHS = {
  INVITATION_TOKEN: '/invitation-token',
  VERIFICATION_TOKEN: '/verification-token',
  CREATE_PASSWORD: '/create-password',
  SIGN_UP: '/signup',
  SIGN_IN: '/sign-in',
  FORGOT_PASSWORD: '/forgot-password',
  FORGOT_PASSWORD_CODE: '/forgot-password-code',
  RESET_TOKEN: '/reset-token',
  RESET_PASSWORD: '/reset-password',
  TERMS_OF_USE: '',
  PRIVACY_POLICY: '',
  APP: '/app',
  APP_: APP_PATHS.APP_ + '*',
  APP_DASHBOARD: APP_PATHS.APP_ + ACCOUNT_PATHS.DASHBOARD,
  APP_MARKETPLACE: APP_PATHS.APP_ + ACCOUNT_PATHS.MARKETPLACE,
  APP_MARKETPLACE_VIEW: APP_PATHS.APP_ + ACCOUNT_PATHS.MARKETPLACE_,
  APP_MARKETPLACE_CHECKOUT: APP_PATHS.APP_ + ACCOUNT_PATHS.MARKETPLACE_ + MARKETPLACE_PATHS.CHECKOUT_,
  APP_MARKETPLACE_CHECKOUT_VIEW: APP_PATHS.APP_ + ACCOUNT_PATHS.MARKETPLACE_ + MARKETPLACE_PATHS.CHECKOUT,
  PUBLIC_MARKETPLACE: PUBLIC_MARKETPLACE_PATHS.BASE,
  PUBLIC_MARKETPLACE_: PUBLIC_MARKETPLACE_PATHS.BASE_,
  PUBLIC_MARKETPLACE_PROFILE_VIEW: PUBLIC_MARKETPLACE_PATHS.PROFILE_,
  PUBLIC_MARKETPLACE_CART: PUBLIC_MARKETPLACE_PATHS.CART,
  APP_MARKETPLACE_PROFILE_VIEW: APP_PATHS.APP_ + ACCOUNT_PATHS.MARKETPLACE_ + MARKETPLACE_PATHS.PROFILE_ACCOUNT,
  APP_ANIMAL_MANAGEMENT: APP_PATHS.APP_ + APP_PATHS.ANIMAL_MANAGEMENT,
  APP_ANIMAL_MANAGEMENT_: APP_PATHS.APP_ + APP_PATHS.ANIMAL_MANAGEMENT_,
  APP_SPECIES_BREED_MANAGEMENT: APP_PATHS.APP_ + APP_PATHS.SPECIES_BREED_MANAGEMENT,
  APP_INVENTORY: APP_PATHS.APP_ + ACCOUNT_PATHS.INVENTORY,
  APP_UPDATE_WITHDRAW_TRANSACTION: APP_PATHS.APP_ + ACCOUNT_PATHS.INVENTORY_ + ACCOUNT_PATHS.UPDATE_WITHDRAW_TRANSACTION_,
  APP_INVENTORY_MANAGEMENT: APP_PATHS.APP_ + APP_PATHS.INVENTORY_MANAGEMENT,
  APP_INVENTORY_MANAGEMENT_COLLECT_DEPOSIT:
    APP_PATHS.APP_ + APP_PATHS.INVENTORY_MANAGEMENT_ + INVENTORY_MANAGEMENT_PATHS.COLLECT_DEPOSIT,
  APP_INVENTORY_MANAGEMENT_MOVE: APP_PATHS.APP_ + APP_PATHS.INVENTORY_MANAGEMENT_ + INVENTORY_MANAGEMENT_PATHS.MOVE,
  APP_INVENTORY_MANAGEMENT_CHECK_IN: APP_PATHS.APP_ + APP_PATHS.INVENTORY_MANAGEMENT_ + INVENTORY_MANAGEMENT_PATHS.CHECK_IN,
  APP_INVENTORY_MANAGEMENT_CHECK_OUT: APP_PATHS.APP_ + APP_PATHS.INVENTORY_MANAGEMENT_ + INVENTORY_MANAGEMENT_PATHS.CHECK_OUT,
  APP_INVENTORY_MANAGEMENT_DISCARD: APP_PATHS.APP_ + APP_PATHS.INVENTORY_MANAGEMENT_ + INVENTORY_MANAGEMENT_PATHS.DISCARD,
  APP_INVENTORY_MANAGEMENT_CANISTER_CONTENTS:
    APP_PATHS.APP_ + APP_PATHS.INVENTORY_MANAGEMENT_ + INVENTORY_MANAGEMENT_PATHS.CANISTER_CONTENTS,
  APP_INVENTORY_MANAGEMENT_RECONCILE: APP_PATHS.APP_ + APP_PATHS.INVENTORY_MANAGEMENT_ + INVENTORY_MANAGEMENT_PATHS.RECONCILE,
  APP_INVENTORY_MANAGEMENT_RECONCILE_: APP_PATHS.APP_ + APP_PATHS.INVENTORY_MANAGEMENT_ + INVENTORY_MANAGEMENT_PATHS.RECONCILE_,
  APP_TRANSACTION_MANAGEMENT: APP_PATHS.APP_ + APP_PATHS.TRANSACTION_MANAGEMENT,
  APP_TRANSACTION_MANAGEMENT_WITHDRAW: APP_PATHS.APP_ + APP_PATHS.TRANSACTION_MANAGEMENT_WITHDRAW,
  APP_TRANSACTION_MANAGEMENT_ADJUST: APP_PATHS.APP_ + APP_PATHS.TRANSACTION_MANAGEMENT_ADJUST,
  APP_TRANSACTION_MANAGEMENT_VIEW: APP_PATHS.APP_ + APP_PATHS.TRANSACTION_MANAGEMENT_,
  APP_TRANSACTION_HISTORY: APP_PATHS.APP_ + ACCOUNT_PATHS.TRANSACTION_HISTORY,
  APP_TRANSACTION_HISTORY_VIEW: APP_PATHS.APP_ + ACCOUNT_PATHS.TRANSACTION_HISTORY_,
  APP_CUSTOMER_INFO: APP_PATHS.APP_ + APP_PATHS.CUSTOMER_INFO,
  APP_CUSTOMER_INFO_VIEW: APP_PATHS.APP_ + APP_PATHS.CUSTOMER_INFO_,
  APP_ADD_ACCOUNT: APP_PATHS.APP_ + APP_PATHS.ADD_ACCOUNT,
  APP_SETTINGS: APP_PATHS.APP_ + ACCOUNT_PATHS.SETTINGS,
  APP_ACCOUNT_SETTINGS: APP_PATHS.APP_ + ACCOUNT_PATHS.ACCOUNT_SETTINGS,
  APP_SETTINGS_PASSWORD: APP_PATHS.APP_ + ACCOUNT_PATHS.SETTINGS_ + SETTINGS_PATHS.PASSWORD,
  APP_USER_PROFILE: APP_PATHS.APP_ + APP_PATHS.USER_PROFILE,
  APP_USER_PROFILE_UPDATE: APP_PATHS.APP_ + APP_PATHS.USER_PROFILE_ + USER_PROFILE_PATHS.UPDATE,
  APP_TEAM_MANAGEMENT: APP_PATHS.APP_ + ACCOUNT_PATHS.TEAM_MANAGEMENT,
  APP_TEAM_MANAGEMENT_EDIT: APP_PATHS.APP_ + ACCOUNT_PATHS.TEAM_MANAGEMENT_,
  APP_APPLICATION_TEAM: APP_PATHS.APP_ + APP_PATHS.APPLICATION_TEAM,
  APP_APPLICATION_TEAM_EDIT: APP_PATHS.APP_ + APP_PATHS.APPLICATION_TEAM_,
  APP_ADMIN_SETTINGS: APP_PATHS.APP_ + APP_PATHS.ADMIN_SETTINGS,
  APP_ON_FARM_BILLING_MANAGEMENT: APP_PATHS.APP_ + APP_PATHS.ON_FARM_BILLING_MANAGEMENT,
  APP_TRANSACTION_CART: APP_PATHS.APP_ + APP_PATHS.TRANSACTION_CART,
  APP_TRANSACTION_CART_WITHDRAW: APP_PATHS.APP_ + APP_PATHS.TRANSACTION_CART_WITHDRAW,
  APP_ADMIN_UPDATE_WITHDRAW_TRANSACTION: APP_PATHS.APP_ + APP_PATHS.TRANSACTION_MANAGEMENT_UPDATE_WITHDRAW_TRANSACTION,
  APP_ON_FARM_MANAGEMENT_CANISTER_CONTENTS: APP_PATHS.APP_ + ACCOUNT_PATHS.ON_FARM_ + ON_FARM_PATHS.CANISTER_CONTENTS,
  APP_ON_FARM_MANAGEMENT_MOVE: APP_PATHS.APP_ + ACCOUNT_PATHS.ON_FARM_ + ON_FARM_PATHS.MOVE,
  APP_ON_FARM_INVENTORY: APP_PATHS.APP_ + ACCOUNT_PATHS.ON_FARM_ + ON_FARM_PATHS.INVENTORY,
  APP_ON_FARM_SETTINGS: APP_PATHS.APP_ + ACCOUNT_PATHS.ON_FARM_ + ON_FARM_PATHS.SETTINGS,
};
